import BillingHTTP from 'utils/billing-http';

class NotificationTokenService {
  create(studentToken) {
    const data = {
      student_token: studentToken,
      device_type: 'PWA',
      provider: 'provider',
    };

    return BillingHTTP.post('/dashboard-api/v2/notification_token', data);
  }
}

export default new NotificationTokenService();
